import { IPortinForm } from "@common/portIn/IPortinForm";
import { OFFER_CONFIG } from "@constants";
import { parse } from "date-fns";

export interface IPortInRequestPayload {
    brand: string;
    direction: string;
    oldId?: number;
    orderNumber?: string;
    otherNetworkAccountNumber: string;
    otherNetworkId: number;
    phoneNumber: string;
    portStartDateTime: string;
    serviceId: number;
    type: string;
}

export const getStateToPayload = (
    formData: IPortinForm,
    currentProviderId: number,
    phoneNumberSelected: string,
    serviceId: number
): IPortInRequestPayload => {
    const accountNumberInput = formData.paymentType.includes("BILL") ? formData.accountNumber : "";
    const portStartDateTime = parse(formData.time, "HH:mm", formData.date ?? new Date()).toISOString();

    return {
        brand: OFFER_CONFIG.BRAND,
        direction: "PORT_IN",
        orderNumber: undefined,
        otherNetworkAccountNumber: accountNumberInput ?? "",
        otherNetworkId: currentProviderId,
        phoneNumber: phoneNumberSelected,
        portStartDateTime,
        serviceId,
        type: formData.paymentType,
    };
};
